module.exports = __webpack_public_path__ + "static/media/img7.8b04e3a3.jpg";